import { EDITOBJECTIVE_SUCCESS, EDITOBJECTIVE_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const editObjectiveReducer = (state = initialState, action) => {
    switch (action.type) {
        case EDITOBJECTIVE_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case EDITOBJECTIVE_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default editObjectiveReducer;
